// services/supabaseClient/sessionsService.js

import { supabase } from './supabaseClient';

const sessions_table_name = 'ml_sessions_staging';
const shared_course_views_table_name = 'ml_shared_course_views_staging';

// 🔒 Track login session
export const trackSession = async (userId) => {
  const { error } = await supabase.from(sessions_table_name).insert([
    {
      user_id: userId,
      created_at: new Date().toISOString(),
    },
  ]);

  if (error) {
    // eslint-disable-next-line no-console
    console.error(`[sessionsService] Failed to track session:`, error);
  }
};

// 📦 Track course opened via shared link
export const trackSharedCourseView = async (userId, courseId) => {
  const { error } = await supabase.from(shared_course_views_table_name).insert([
    {
      user_id: userId,
      course_id: courseId,
      viewed_at: new Date().toISOString(),
    },
  ]);

  if (error) {
    // eslint-disable-next-line no-console
    console.error(`[sessionsService] Failed to track course view:`, error);
  }
};
